import { render, staticRenderFns } from "./GraphDetail60.vue?vue&type=template&id=62cdcab6&scoped=true"
import script from "./GraphDetail60.vue?vue&type=script&lang=js"
export * from "./GraphDetail60.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cdcab6",
  null
  
)

export default component.exports